import { render, staticRenderFns } from "./profile-items.vue?vue&type=template&id=16154418&scoped=true&"
import script from "./profile-items.vue?vue&type=script&lang=js&"
export * from "./profile-items.vue?vue&type=script&lang=js&"
import style0 from "./profile-items.vue?vue&type=style&index=0&id=16154418&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16154418",
  null
  
)

export default component.exports